// Barrel export for the v2 design system primitives.
// See: .claude/skills/rehaut-design/HANDOFF.md
//
// Pages import from '@/components/system' so the import surface is
// stable as primitives are added or restructured. Tickets / Notas /
// Reportes will pull from the same place when their v2 ports land.

export { StatusDot, type DotStatus } from './StatusDot';
export { TypeBadge } from './TypeBadge';
export { Expediente } from './Expediente';
export { KeyHint } from './KeyHint';
export { Field } from './Field';
export { SectionLabel } from './SectionLabel';
export { ProgressBar } from './ProgressBar';
export { useCountUp } from './useCountUp';
export { useCountUpFloat } from './useCountUpFloat';
export { FigureReveal } from './FigureReveal';
export { useDrawProgress } from './useDrawProgress';
export { LivePulse } from './LivePulse';
export { staffInitials, staffFirstName } from './staffInitials';
export { daysBetween, relativeDate, relativeDateSigned, formatDate, formatMoney, age, monthYearCdmx, formatClinicalDate, formatClinicalDateLong, clinicalDateKey, todayEyebrowMx } from './dateHelpers';
export { notaSummary } from './notaSummary';
export { Icon, type IconName } from './Icon';
// Gastos primitives — reused across modules per the brief.
export { CategoryMark } from './CategoryMark';
export { VendorAvatar } from './VendorAvatar';
export { MoneyCell } from './MoneyCell';
export { ReceiptIcon } from './ReceiptIcon';
export { fmtMoney, toMXN, FX_USD_MXN_FALLBACK, type Currency } from './moneyHelpers';
// FLAGSHIPS Phase 1 primitives — see docs/superpowers/specs/FLAGSHIPS-HANDOFF.md
export { Button, type ButtonVariant } from './Button';
export { Chip, type ChipTone } from './Chip';
export { Ring, type RingTone } from './Ring';
export { Figure } from './Figure';
export { Eyebrow } from './Eyebrow';
export { Stage } from './Stage';
